module.exports = __webpack_public_path__ + "static/media/algolia-logo.22b61a0f.svg";